<template>
  <section>
    <h1 class="section-head">{{ title }}</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <router-link class="button is-danger is-pulled-left" :to="backPage"
            ><i class="fas fa-arrow-left"></i>Back</router-link
          >
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <button
              class="button is-success is-pulled-right"
              :class="loadingClass"
              @click="submit"
            >
              <i class="fas fa-clipboard-list"></i>บันทึก
            </button>
          </div>
        </div>
      </div>
    </nav>

    <div class="columns">
      <div class="column">
        <h2 class="section-sub-head">Details</h2>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Group</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input
                  name="group"
                  class="input "
                  type="text"
                  placeholder="Group"
                  v-model="group.name"
                  :disabled="isEditing"
                  v-validate="'required|min:4|max:35'"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-key"></i>
                </span>
              </p>
              <span>{{ errors.first("name") }}</span>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Name</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input
                  name="description"
                  class="input "
                  type="text"
                  placeholder="Name"
                  v-model="group.description"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-key"></i>
                </span>
              </p>
              <span>{{ errors.first("description") }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="column">
        <h2 class="section-sub-head">Permission</h2>
        <div
          v-for="permission in parentPermFiltered"
          v-bind:key="permission.id"
        >
          <h3 class="section-mini-head">{{ permission.name }}</h3>
          <div class="block has-background-lightgray has-padding-5">
            <b-checkbox
              v-for="sub_permission in childPermFiltered(permission.id)"
              v-bind:key="sub_permission.id"
              :native-value="sub_permission.id"
              v-model="permissionsChecked"
            >
              {{ sub_permission.name }}
            </b-checkbox>
          </div>
        </div>
      </div>
    </div>

    <b-loading
      :is-full-page="false"
      :active.sync="isLoading"
      :canCancel="false"
    ></b-loading>
  </section>
</template>

<script>
import Request from "@/libraries/request";
import UserModel from "@/model/user_model";
import PermissionModel from "@/model/permission_model";

export default {
  name: "User_Add",
  data() {
    return {
      group: {
        name: "",
        description: ""
      },
      permissions: [],
      permissionsChecked: [],
      title: "เพิ่มกลุ่มผู้ใช้งาน",
      backPage: "/group",
      loadingClass: "",
      isLoading: true,
      isEditing: this.$route.params.id ? true : false,

      submitted: false
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    isRequired() {
      return this.$route.params.id ? "" : "required|";
    },
    parentPermFiltered() {
      return this.permissions.filter(perm => {
        if (perm.parent_id == 0) {
          return perm;
        }
      });
    }
  },
  methods: {
    async init() {
      if (this.$route.params.id) {
        this.group = await UserModel.get_groups(this.$route.params.id);
        this.group = this.group[0];
        this.title = "แก้ไขกลุ่มผู้ใช้งาน - " + this.group.description;
        this.permissionsChecked = this.checkedPermFiltered();
      }
      this.permissions = await PermissionModel.get_permissions();
      this.isLoading = false;
    },
    checkedPermFiltered() {
      let permList = [];
      if (this.group.perm) {
        this.group.perm.forEach(perm => {
          permList.push(perm.per_id);
        });
      }
      return permList;
    },
    childPermFiltered(id) {
      return this.permissions.filter(perm => {
        if (perm.parent_id == id) {
          return perm;
        }
      });
    },
    submit() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          //alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.group))
          this.isLoading = true;
          let data = {
            id: this.$route.params.id ? this.$route.params.id : "",
            name: this.group.name,
            description: this.group.description,
            permissions: this.permissionsChecked
          };
          Request.post("group/add", data, res => {
            if (res.data.status) {
              this.isLoading = false;
              this.$buefy.snackbar.open("บันทึกสำเร็จ!");
              this.$router.push("/group");
            } else {
              this.$buefy.toast.open("ไม่สามารถบันทึกได้! - " + res.data.msg);
            }
          });
        } else {
          this.$buefy.toast.open("กรุณากรอกข้อมูลให้ครบถ้วน!");
        }
      });
    }
  }
};
</script>

<style scoped>
.has-background-lightgray {
  background-color: #f7f7f7;
}
.has-padding-5 {
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Group/add.vue